import { FC, ReactNode } from 'react'
import { COLORS } from '@assets/styles/colors'

interface ProgressContainerProps {
	maxTime: number
	currentTime: number
	children: ReactNode
}

export const ProgressContainer: FC<ProgressContainerProps> = ({
	maxTime,
	currentTime,
	children,
}) => {
	const progressPercentage = (currentTime / maxTime) * 100

	return (
		<div style={{ position: 'relative', width: '100%', height: 314, marginTop: 10 }}>
			{children}
			<div
				style={{
					position: 'absolute',
					bottom: 10,
					left: '50%',
					transform: 'translateX(-50%)',
					width: '90%',
					height: 5,
					backgroundColor: 'rgba(0, 0, 0, 0.5)',
					borderRadius: 10,
					background: 'white',
				}}>
				<div
					style={{
						width: `${progressPercentage}%`,
						height: '100%',
						backgroundColor: COLORS.DECORATIVE_YELLOW,
						borderRadius: 10,
					}}
				/>
			</div>
		</div>
	)
}
